
if (!window.customElements.get('gtc-faq-item')) {
  class GtcFaqItem extends HTMLElement {
    static get observedAttributes() {
      return ['open'];
    }

    // Add any initialization code here
    constructor() {
      super();
      this.dom = {
        trigger: null,
        content: null
      }

      this.dom.trigger = this.querySelector('[aria-controls]');
      this.dom.content = this.querySelector(`#${ this.dom.trigger.getAttribute('aria-controls') }`);

      this.settings = {
        id: this.getAttribute('id'),
        groupId: this.getAttribute('group-id'),
        closeOthers: false,
        animationDuration: 300,
        animationOpenTimeout: null,
        animationCloseTimeout: null,
        scrollTo: false
      }
    }

    // Add code to run when the element is inserted into the DOM
    connectedCallback() {
      this.CheckUrlParams();

      this.SetA11yAttributes();

      if (this.hasAttribute('single')) {
        this.setAttribute('aria-multiselectable', 'false');
        this.settings.closeOthers = true;
      }
      else {
        this.setAttribute('aria-multiselectable', 'true');
      }

      if (this.settings.scrollTo) {
        this.setAttribute('aria-expanded', 'true');
        this.settings.scrollTo = false;
        if (history.scrollRestoration) {
          history.scrollRestoration = "manual";
        }
        this.scrollIntoView({ behavior: 'smooth' });
      }

      this.AddEventListeners();
    }

    // Add code to run when the element is removed from the DOM
    disconnectedCallback() {
      this.RemoveEventListeners();
    }

    // Update the element
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'open') {

        // This is placed here to ensure that the animation duration is set after the element is connected to the DOM, in case the FAQ item has "open on load"
        if (!this.settings.animationDuration) this.GetAnimationDuration();

        if (newValue !== null) {

          // this.dom.content.removeAttribute('hidden');
          this.setAttribute('aria-expanded', 'true');
          this.AnimateHeight({ expand: true });

        } else {
          this.setAttribute('aria-expanded', 'false');
          this.AnimateHeight({ expand: false });
        }
      }
    }

    // Add a11y attributes
    SetA11yAttributes() {
      this.setAttribute('role', 'heading');
      this.setAttribute('aria-level', '3');
      this.setAttribute('aria-expanded', 'false');
    }

    // Add event listeners
    AddEventListeners() {
      this.dom.trigger.addEventListener('click', this.Toggle.bind(this));

      // Add close-others event listener
      if (this.settings.closeOthers) {
        document.addEventListener(`close-others-${ this.settings.groupId }`, this.CloseOthers.bind(this));
      }
    }

    // Remove event listeners
    RemoveEventListeners() {
      this.dom.trigger.removeEventListener('toggle', this.Toggle.bind(this));

      // Remove close-others event listener
      if (this.settings.closeOthers) {
        document.removeEventListener(`close-others-${ this.settings.groupId }`, this.CloseOthers.bind(this));
      }
    }

    // Close all other accordions
    CloseOthersEvent() {
      document.dispatchEvent(new CustomEvent(`close-others-${ this.settings.groupId }`,
        {
          detail: this.settings.id,
          bubbles: true
        }
      ));
    }

    // Close all other accordions
    CloseOthers(event) {
      if (event.detail !== this.settings.id) {
        this.removeAttribute('open');
      }
    }

    // Toggle the accordion
    Toggle() {
      if (this.hasAttribute('open') === false) {
        this.setAttribute('open', '');

        if (this.settings.closeOthers) {
          this.CloseOthersEvent();
        }

        this.SetUrlUrlParams();
      } else {
        this.removeAttribute('open');
        this.DeleteUrlUrlParams();
      }
    }

    AnimateHeight({ expand = true }) {
      const element = this.dom.content;

      if (this.settings.animationCloseTimeout) {
        clearTimeout(this.settings.animationCloseTimeout)
      }

      if (expand) {
        this.dom.content.classList.add('visible');

        element.style.maxHeight = `${ element.scrollHeight }px`;
      } else {

        if (this.settings.animationOpenTimeout) {
          clearTimeout(this.settings.animationOpenTimeout)
        }

        element.style.maxHeight = `${ element.scrollHeight }px`;
        void element.scrollHeight;
        element.style.maxHeight = '0';

        this.settings.animationCloseTimeout = setTimeout(() => {
          this.dom.content.classList.remove('visible');
        }, this.settings.animationDuration);
      }
    }

    GetAnimationDuration() {
      const ms = window.getComputedStyle(this.dom.content).transitionDuration.includes('ms');

      this.settings.animationDuration = (parseFloat(window.getComputedStyle(this.dom.content).transitionDuration)) * (!ms ? 1000 : 1)
    }
    SetUrlUrlParams() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.set('faq', this.settings.id);
      url.search = params.toString();

      window.history.replaceState({}, '', url);
    }

    DeleteUrlUrlParams() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.delete('faq');
      url.search = params.toString();

      window.history.replaceState({}, '', url);
    }

    CheckUrlParams() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      const faqItemId = params.get('faq');

      if (faqItemId === this.settings.id) {
        this.setAttribute('open', '');
        this.settings.scrollTo = true;
      }
    }
  }

  // Define the custom element

  customElements.define('gtc-faq-item', GtcFaqItem);
}


if (!window.customElements.get('video-autoplay')) {
  class VideoAutoplay extends HTMLElement {
    constructor() {
      super();

      this.videoElement = null;
      this.intersectionObserver = null;
    }

    connectedCallback() {
      this.videoElement = this.querySelector('video');
      if (this.videoElement) {
        this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0 });
        this.intersectionObserver.observe(this.videoElement);
      }

    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.unobserve(this.videoElement);
        this.intersectionObserver = null;
      }
    }

    handleIntersection(entries) {
      const isVisible = entries[0].isIntersecting;
      if (isVisible && (this.videoElement.hasAttribute('autoplay') || this.videoElement.played.length > 0)) {
        // this.playVideo();
      } else {
        this.pauseVideo();
      }
    }

    playVideo() {
      if (this.videoElement) {
        this.videoElement.play();
      }
    }

    pauseVideo() {
      if (this.videoElement) {
        this.videoElement.pause();
      }
    }
  }

  customElements.define('video-autoplay', VideoAutoplay);

}